module.exports = __webpack_public_path__ + "assets/close-circle-filled-2-a7ee16.svg";